import { Injectable, isDevMode } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";

import { FlowsFIRenewalLoginAction } from "./flows-fi-renewal-login.element.action";
import { FlowsFIRenewalLoginModel, LoginOrderResponse } from "./flows-fi-renewal-login.element.model";
import { FlowsFIRenewalLoginService } from "./flows-fi-renewal-login.element.service";

@State<FlowsFIRenewalLoginModel>({
  name: "flowsFIRenewalLogin",
})
@Injectable()
export class FlowsFIRenewalLoginState {
  constructor(private flowsFIRenewalLoginService: FlowsFIRenewalLoginService) {}
  @Action(FlowsFIRenewalLoginAction.Focused)
  focused({ patchState }: StateContext<FlowsFIRenewalLoginModel>) {
    patchState({ state: "focused" });
  }

  @Action(FlowsFIRenewalLoginAction.Submit)
  async completed(
    { patchState, dispatch }: StateContext<FlowsFIRenewalLoginModel>,
    { flowsFIRenewalLoginModel }: FlowsFIRenewalLoginAction.Submit
  ) {
    try {
      dispatch(new FlowsFIRenewalLoginAction.Loading());
      const response: LoginOrderResponse = await this.flowsFIRenewalLoginService
        .submitSignIn(flowsFIRenewalLoginModel)
        .toPromise();
      if (response.isValidUser && response.isActiveForCampaign) {
        patchState({ state: "completed", ...flowsFIRenewalLoginModel, ...response });
        dispatch(new FlowsFIRenewalLoginAction.Redirect(flowsFIRenewalLoginModel));
      } else if (!response.isValidUser) {
        dispatch(new FlowsFIRenewalLoginAction.Errorred());
      } else {
        dispatch(new FlowsFIRenewalLoginAction.Errorred());
      }
    } catch (error) {
      if (isDevMode()) console.error(error);
      dispatch(new FlowsFIRenewalLoginAction.Errorred());
    }
  }

  @Action(FlowsFIRenewalLoginAction.Errorred)
  errorred({ patchState }: StateContext<FlowsFIRenewalLoginModel>) {
    patchState({ state: "errorred" });
  }

  @Action(FlowsFIRenewalLoginAction.Loading)
  loading({ patchState }: StateContext<FlowsFIRenewalLoginModel>) {
    patchState({ state: "loading" });
  }

  @Action(FlowsFIRenewalLoginAction.Redirect)
  redirect(
    _: StateContext<FlowsFIRenewalLoginModel>,
    { flowsFIRenewalLoginModel }: FlowsFIRenewalLoginAction.Redirect
  ) {
    const queryParams = new URLSearchParams(
      Object.entries(flowsFIRenewalLoginModel).filter(([key, value]) => key !== "redirectToRenewalPageUrl" && !!value)
    ).toString();

    window.location.href = flowsFIRenewalLoginModel.redirectToRenewalPageUrl + `?${queryParams}`;
  }
}
